import {
  HStack,
  IconButton,
  Input,
  InputGroup,
  InputLeftElement,
  Stack,
  Button,
} from '@chakra-ui/react';
import { useSummedOrderedProjects } from '~/common/api/orderingServiceApi/OrderingApi';
import { TotalCalculatedTimes } from '../common/TotalCalculatedTimes';
import { Link } from '~/common/components/defaultUIComponents/Link';
import { OrderedProjectEntry } from './OrderedProjectEntry';
import { ListView } from '~/common/components/ListView';
import { AddIcon, SearchIcon } from '@chakra-ui/icons';
import routes from '~/common/constants/routes.json';
import useTranslate from '~/common/utils/translate';
import { ViewState } from '@its4plan/ordering';
import { useImportant } from '../utils';
import { useState } from 'react';

export function OrderedProjectList() {
  const t = useTranslate();
  const [searchTerm, setSearchTerm] = useState('');
  const [viewState, setViewState] = useState<ViewState | null>(null);
  const { data: summedOrderedProjects = [], isLoading } =
    useSummedOrderedProjects({ viewState: viewState ?? undefined });
  const { uncheckedDone, uncheckedPartiallyDone } = useImportant();
  const changeViewState = (newViewState: ViewState | null): void => {
    if (newViewState !== viewState) {
      setSearchTerm('');
    }
    setViewState(newViewState);
  };
  return (
    <div>
      <HStack pb={3}>
        <Link href={routes.CREATE_ORDER_V2}>
          <IconButton isRound aria-label="add-orders" icon={<AddIcon />} />
        </Link>
        <InputGroup>
          <InputLeftElement pointerEvents="none">
            <SearchIcon />
          </InputLeftElement>
          <Input
            type="search"
            placeholder="Projektaufträge"
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.currentTarget.value)}
          />
        </InputGroup>
        <HStack>
          <Button
            onClick={() => changeViewState(null)}
            bg={viewState === null ? 'green' : 'white'}
            color={viewState === null ? 'white' : 'black'}
            borderColor="gray.500"
            borderWidth="1px"
            variant={viewState === null ? 'solid' : 'outline'}
          >
            {t('ViewState.ALL')}
          </Button>
          <Button
            onClick={() => changeViewState(ViewState.PARTIALLY_DONE)}
            bg={viewState === ViewState.PARTIALLY_DONE ? 'green' : 'white'}
            color={
              uncheckedPartiallyDone > 0
                ? 'red.500'
                : viewState === ViewState.PARTIALLY_DONE
                  ? 'white'
                  : 'black'
            }
            borderColor="gray.500"
            borderWidth="1px"
            variant={
              viewState === ViewState.PARTIALLY_DONE ? 'solid' : 'outline'
            }
          >
            {t(`ViewState.${ViewState.PARTIALLY_DONE}`)}
            {uncheckedPartiallyDone > 0 ? ` (${uncheckedPartiallyDone})` : ''}
          </Button>
          <Button
            onClick={() => changeViewState(ViewState.DONE)}
            bg={viewState === ViewState.DONE ? 'green' : 'white'}
            color={
              uncheckedDone > 0
                ? 'red.500'
                : viewState === ViewState.DONE
                  ? 'white'
                  : 'black'
            }
            borderColor="gray.500"
            borderWidth="1px"
            variant={viewState === ViewState.DONE ? 'solid' : 'outline'}
          >
            {t(`ViewState.${ViewState.DONE}`)}
            {uncheckedDone > 0 ? ` (${uncheckedDone})` : ''}
          </Button>
        </HStack>
      </HStack>
      <TotalCalculatedTimes />
      <ListView
        data={summedOrderedProjects}
        isLoading={isLoading}
        search={searchTerm}
        orderBy={(d) => d.project?.name ?? ''}
        searchFields={(d) => [d.project?.name ?? '']}
        render={({ data }) => (
          <Stack height="80vh" overflowY="auto">
            {data.map((orderedProject, idx) => {
              const project = orderedProject.project;
              if (!project) return null;
              return (
                <OrderedProjectEntry
                  key={project.id ?? idx}
                  orderedProject={orderedProject}
                />
              );
            })}
          </Stack>
        )}
      />
    </div>
  );
}
